import { makeAutoObservable } from 'mobx';
import { FiltersStore } from './FiltersStore';
import { createContext } from 'react';
import { PromiseCompletion } from '../Services/PromiseCompletion';
import { DrawerStore } from '../Components/Drawer/Drawer';
import {authService} from "../index";

export class AppStore {
    public filtersStore = new FiltersStore();
    public siteLoader: PromiseCompletion = new PromiseCompletion();
    public drawerStore: DrawerStore = new DrawerStore();
    public isUser = authService.isUser;


constructor () {
        makeAutoObservable(this);
        !this.isUser &&  void this.filtersStore.getData();
    }

}

export const AppStoreContext = createContext({} as AppStore);
